export default __webpack_public_path__ + "static/media/caricons.2ecef3dc.svg";